import { Prisma } from "@prisma/client";

export enum CreditBucket {
  CALL = "CALL",
  PROSPECT = "PROSPECT",
}

export type CreditWallet = {
  callAllowance: number;
  prospectAllowance: number;
  callRollover: number;
  prospectRollover: number;
  callBalance: number;
  prospectBalance: number;
};

export const CREDIT_WALLET_SELECT = {
  callAllowance: true,
  prospectAllowance: true,
  callRollover: true,
  prospectRollover: true,
  callBalance: true,
  prospectBalance: true,
} satisfies Prisma.UserSelect;

export const EMPTY_CREDIT_WALLET: CreditWallet = {
  callAllowance: 0,
  prospectAllowance: 0,
  callRollover: 0,
  prospectRollover: 0,
  callBalance: 0,
  prospectBalance: 0,
};

// Nothing crosses from one bucket to the other, added credits included: an hour bought is an
// hour, and analysing prospects can never eat into it.
export const CREDIT_WALLET_DRAW_ORDER: Record<CreditBucket, (keyof CreditWallet)[]> = {
  [CreditBucket.CALL]: ["callAllowance", "callRollover", "callBalance"],
  [CreditBucket.PROSPECT]: ["prospectAllowance", "prospectRollover", "prospectBalance"],
};

export const CREDIT_WALLET_BALANCE: Record<CreditBucket, keyof CreditWallet> = {
  [CreditBucket.CALL]: "callBalance",
  [CreditBucket.PROSPECT]: "prospectBalance",
};
